import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Info, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PayslipDataNoticeProps {
  hasAllowances: boolean;
  hasDeductions: boolean;
  onConfigurePayroll?: () => void;
}

export const PayslipDataNotice = ({ 
  hasAllowances, 
  hasDeductions, 
  onConfigurePayroll 
}: PayslipDataNoticeProps) => {
  if (hasAllowances && hasDeductions) {
    return null; // Don't show notice if data is already populated
  }

  return (
    <Alert className="mb-4">
      <Info className="h-4 w-4" />
      <AlertTitle>Payslip Configuration Required</AlertTitle>
      <AlertDescription className="mt-2">
        <div className="space-y-2">
          <p>This payslip appears to be missing allowance and deduction details. To populate this data:</p>
          
          <div className="text-sm space-y-1">
            <p><strong>For Allowances:</strong></p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Go to Payroll → Employee Payroll Items</li>
              <li>Add allowances like Housing, Transport, Medical, etc.</li>
              <li>Set the amounts and calculation methods</li>
            </ul>
            
            <p><strong>For Deductions:</strong></p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Configure NAPSA contributions (5% of basic salary)</li>
              <li>Set up PAYE tax calculations</li>
              <li>Add any advances, loans, or other deductions</li>
            </ul>
          </div>
          
          {onConfigurePayroll && (
            <div className="mt-3">
              <Button 
                size="sm" 
                variant="outline"
                onClick={onConfigurePayroll}
                className="mr-2"
              >
                <ExternalLink className="h-4 w-4 mr-1" />
                Configure Payroll
              </Button>
            </div>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
};






